//トップページ　キービジュアルスライダー
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade} from 'swiper/modules';

export function idxFunc() {
  let indexTop = $("#indexTop").length;
  let resizecheck = $('#responsibleCheck').width();

  if(indexTop){
    let resizecheck = $('#responsibleCheck').width();
    let resizecheck2 = 0;

    //ホバーで画像を切り替え
    let hoverCount = $(".servicesConList li").length;
    let isHoverEnabled = false;
    
    $(window).on('load resize', function () {
      resizecheck = $('#responsibleCheck').width();
      enableHover();
    });

    function enableHover() {
      if (resizecheck == '1' && !isHoverEnabled) {
        for (let i = 0; hoverCount >= i; i++) {
          let hoverTarget = $(`.servicesConList li:nth-child(${i})`);
          let changeTarget = $("#change00");
          let changeImage = $(`#change0${i}`);
          hoverTarget.hover(
            function () {
              changeImage.css({
                opacity: "1",
              });
            },
            function () {
              changeImage.css({
                opacity: "0",
              });
              changeTarget.css({
                opacity: "1",
              });
            }
          );
        }
        isHoverEnabled = true;
      } else if (resizecheck == '2' && isHoverEnabled) {
        $(".servicesConList li").off("mouseenter mouseleave");
        isHoverEnabled = false;
      }
    }
    enableHover();

    //FVアニメーション
    const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms))
    wait(0)
    .then(() =>{
      $(".mainview").addClass('isShow');
      return wait(100)
    })
    .then(() =>{
      $("#indexTop").addClass('isShow');
      return wait(600)
    })
    .then(() =>{
      $(".firstMainviewImgAnime").addClass('isShow');
      return wait(600)
    })
    .then(() => {
      $('.firstMainviewTxtAnime').addClass('isShow');
      return wait(400)
    })

    function indexCommonAnimeFunc() {
      $('.commonOneColumn').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 300) {
          wait(0)
          .then(() => {
            if (!$(this).find('.commonAnimeTit').hasClass('isShow')) {
              $(this).find('.commonAnimeTxt').addClass('isShow');
              $(this).find('.commonAnimeTit').addClass('isShow');
              $(this).find('.moreBtn').addClass('isShow');
            }
            if (!$(this).find('.newsArt').hasClass('isShow')) {
              $(this).find('.newsArt').addClass('isShow');
            }
            return wait(600)
          })
          .then(() =>{
            if (!$(this).find('.imgBox01').hasClass('isShow')) {
              $(this).addClass('isShow');
              $(this).find('.imgBox01').addClass('isShow');
              $(this).find('.servicesCon').addClass('isShow');
            }
            return wait(200)
          })
        }
      });

      $('.commonTwoColumn').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 300) {
          wait(0)
          .then(() => {
            if (!$(this).find('.commonAnimeTit').hasClass('isShow')) {
              $(this).addClass('isShow');
              $(this).find('.commonAnimeTit').addClass('isShow');
              $(this).find('.commonAnimeTxt').addClass('isShow');
              $(this).find('.moreBtn').addClass('isShow');
              $(this).find('.imgBox').addClass('isShow');
            }
            return wait(300)
          })
        }
      });
      
      $('.commonThreeColumn').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 300) {
          wait(0)
          .then(() => {
            if (!$(this).find('.imgBox01').hasClass('isShow')) {
              $(this).addClass('isShow');
              $(this).find('.imgBox01').addClass('isShow');
              $(this).find('.imgBox02').addClass('isShow');
              $(this).find('.commonAnimeTit').addClass('isShow');
              $(this).find('.commonAnimeTxt').addClass('isShow');
              $(this).find('.moreBtn').addClass('isShow');
            }
            return wait(200)
          })
        }
      });

    }indexCommonAnimeFunc();

    $(window).on('load scroll', function () {
      indexCommonAnimeFunc();
    });
  }
}